import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { fetchAuthUserSuccess } from "../../store/modules/user/actions";
import { projectServices } from '../../services/projectServices'
import { fetchUbication } from '../../store/modules/location/actions'
import CryptoJS from 'crypto-js';
import {
    fetchHideLoading,
    fetchShowLoading,
  } from "../../store/modules/layout/actions";

import {
    CRYPTOLOAD
  } from '../../utils/constants/login';

import Page from '../../containers/LoginMiCuenta'

const Externo = () => {
    const { externo } = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    if(externo && isValidURIComponent(externo)){
        dispatch(fetchShowLoading());
        const decodeString = atob(externo)

        try{
            const bytes = CryptoJS.AES.decrypt(decodeString, CRYPTOLOAD);
            const objetoDesencriptado = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            
            const responseData = {
                nombreCliente: objetoDesencriptado.nombreCliente,
                numeroDocumento: objetoDesencriptado.numeroDocumento,
                tipoDocumento: objetoDesencriptado.tipoDocumento,
                idTipoDocumento: objetoDesencriptado.idTipoDocumento,
                producto: objetoDesencriptado.producto,
                token: objetoDesencriptado.token,
                correo: objetoDesencriptado.correo
            }  
            
            const data = { 
                    user: responseData.correo, 
                    password: "********", 
                    aceptaDatosPersonales: true, 
                    aceptaTratamiento: false 
                }
    
            dispatch(
                    fetchAuthUserSuccess({
                        ...responseData, 
                        ...data,
                        nroDocumento: objetoDesencriptado.numeroDocumento,
                        tipoDocumento: "0" + responseData.idTipoDocumento
                    })
            );

            window.localStorage.setItem("login", "letter");
            localStorage.setItem('token', objetoDesencriptado.token);
            projectServices.getDestinations(`0${responseData.idTipoDocumento}`, responseData.numeroDocumento).then(responseUbicacion => {
                        dispatch(fetchUbication(responseUbicacion.data))
                    }).finally(() => {
                        dispatch(fetchHideLoading())
                        return history("/");
                    })

        }
        catch (e) {
            console.log("ERROR EXTERNO LINK")
            dispatch(fetchHideLoading())
            return <React.Fragment>
                    <Page />
                </React.Fragment>;    
        }
    }    

    return <React.Fragment>
            <Page />
        </React.Fragment>;

}

const isValidURIComponent = (encodedString) => {
    try {
      atob(encodedString);  
      return true;
    } catch (e) {
      return false;    
    }
  };

Externo.propTypes = {
    children: PropTypes.node
}

export default Externo
